import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

class CarsMenu extends Component {
  constructor () {
    super();
    this.state = {
    };
  }
  componentWillMount() {
    if (this.props.pageControl.subMenu === '') this.props.setSubMenu('active');
  }
  setSubMenu = (page) => {
    this.props.setSubMenu(page);
  }
  render() {
    return (
      <div className="bodu-menuCars">
        <div className="title-carsMenu">Cars</div>
        <button
          className={`button-carsMenu ${this.props.pageControl.subMenu === 'active' && '-active'}`}
          onClick={() => this.setSubMenu('active')}
        >ACTIVE
        </button>
        {/* <button
          className={`button-carsMenu ${this.props.pageControl.subMenu === 'orders' && '-active'}`}
          onClick={() => this.setSubMenu('orders')}
        >ORDERS
        </button>
        <button
        className={`button-carsMenu ${this.props.pageControl.subMenu === 'inLeasing' && '-active'}`}
          onClick={() => this.setSubMenu('inLeasing')}
        >IN LEASING
        </button> */}
      </div>
    );
  }
}

CarsMenu.propTypes = {
  setSubMenu: PropTypes.func.isRequired,
  pageControl: PropTypes.instanceOf(Object).isRequired
};
export default CarsMenu;



// WEBPACK FOOTER //
// ./src/pages/CarEditorPage/components/carsMenu/index.js